<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :row-class-name="rowClassName"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="orderNo"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <!--未关联到数据则隐藏按钮-->
          <el-tooltip class="item" effect="dark" content="查看" placement="top" v-if="row.orderCode">
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  code: row.orderCode
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)" v-if="row.orderCode">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
      <template v-slot:olyOrderStatusDesc="{ row }">
        <div>
          <span> {{ row.olyOrderStatusDesc }}</span>
          <br />
          <span> {{ row.syncTime }}</span>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      previewDialogOptions: {
        viewVisible: false,
        code: ''
      },
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      selectList: [],
      fullScreenLoading: false,
      orderDetailDialogOptions: {
        no: '',
        visible: false
      },
      //标示订单推送数据关联的JSTMS订单是否存在
      rowClassName: ({ row }) => {
        if (row.orderCode === null || row.orderCode === '') {
          return 'bg-danger text-white'
        }
        return ''
      },
    }
  },
  methods: {
    //打开详情页面
    openEditPage({ pageType, code }) {
      this.$router.push({
        name: 'carriage-order-detail',
        params: { orderCode: code, pageType }
      })
    },
    //打开订单详情页面
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no }
      })
    }
  }
}
</script>
